<template>
  <div v-if="allGroups.length > 0">
    <h5 class="mt-6 mb-4">Группы, в которых участвует оператор:</h5>
    <vx-card noShadow cardBorder class="mb-4" v-for="group in allGroups" :key="group.slug">
      <vs-checkbox
        class="items-start"
        :value="selectedGroups.includes(group.slug)"
        :disabled="true"
      >
        <b>{{ group.name }}</b><br>
        <p>{{ group.description }}</p>
      </vs-checkbox>
    </vx-card>
  </div>
</template>

<script>
import Groups from '../../api/http/models/Groups'

export default {
  props: {
    operatorsGroups: {
      type: Array,
      required: true
    },
    companySlug: {
      type: String,
      required: true
    },
    operatorsEmail: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      allGroups: [],
      selectedGroups: []
    }
  },
  async created () {
    const response = await Groups.getAll(this.companySlug)
    this.allGroups = response.data || []
    this.selectedGroups = this.operatorsGroups.map(group => group.slug)
  }
}
</script>
